import api from '../../../App/socket';

export const filterSearch = (where) => {
    return (
        api.send({
            api: 'db',
            model: 'Bike_model',
            action: 'Read',
            options: {
                attributes: 'all',
                limit: 10,
                include: [
                    {
                        model: 'Bike_brand',
                        attributes: 'all',
                    },
                    {
                        model: 'Bike_model',
                        attributes: 'all',
                    },
                ],
                where,
                order: {
                    name: 'asc',
                },
            },
        })
            .then(response => response)
            .catch(error => error)
    );
};



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/BikeManagement/requests/filter_search_request.js